/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCartAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 4h2.22l2.56 10.242.75 3 .19.758H18v-2H9.28l-.25-1h9.724l.207-.725 2-7L21.326 6h-2.08l-.572 2-1.428 5H8.53L5.97 2.757 5.78 2H2v2zm9 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm7 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 4v2h-2v2h2v2h2V8h2V6h-2V4h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCartAdd as CartAdd };
